import * as React from 'react';

interface Props {
    touched?: boolean;
    errMessage?: string;
    successMessage?: string;
}
export const FieldValidation = ({ touched, errMessage, successMessage }: Props) => {
    if (touched && errMessage) {
        return (
            <p className="m-form-row__error-message">{errMessage}</p>
        );
    } else if (touched && !errMessage && successMessage) {
        return (
            <p className="m-form-row__validation-message">{successMessage}</p>
        );
    }
    return null;
};